<div class="row">
    <div class="col-12">
        <div class="card card-body">
            <div class="header">
                <h4 class="card-title mb-0">
                    <span class="lstick"></span>Charity Organization
                </h4>

                <div class="d-flex">
                    <a href="javascript:void(0);" class="btn btn-primary"
                        (click)="openModal(editModal, {}, 'Add Donation')" ngbTooltip="Add Donation">
                        + Add Charity
                    </a>
                </div>
            </div>

            <div class="table-responsive" *ngIf="!loading">
                <table class="table table-striped border mt-4">
                    <thead class="table-light">
                        <tr>
                            <th>Charity Name</th>
                            <th>Description</th>
                            <th>Website Link</th>
                            <th>Percentage</th>
                            <th>Created At</th>
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let donation of donationData; let i = index">
                            <td>{{ donation?.charityName }}</td>
                            <td>{{ donation?.charityDescription }}</td>
                            <td>{{ donation?.websiteLink }}</td>
                            <td>{{ donation?.donationPercentage }} %</td>
                            <td>{{ donation?.created_at | date:'medium' }}</td>

                            <td class="d-flex align-items-center">
                                <button class="btn btn-sm btn-primary mr-1"
                                    (click)="openModal(editModal, donation, 'Edit Donation')"
                                    ngbTooltip="Edit Donation">
                                    <i class="fa fa-edit"></i>
                                </button>

                                <button class="btn btn-sm btn-danger"
                                    (click)="openDeleteModal(deleteModal, donation._id)" ngbTooltip="Delete">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>

                        <tr *ngIf="donationData?.length === 0 && !loading">
                            <td colspan="6" class="text-center text-muted">
                                No Charity records found.
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="d-flex justify-content-center mt-4" *ngIf="donationData?.length">
                    <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="totalCount" [maxSize]="7"
                        [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="loadPage($event)">
                    </ngb-pagination>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ADD / EDIT MODAL -->
<ng-template #editModal>
    <div class="modal-header">
        <h5 class="modal-title">{{ modeltitle }}</h5>
        <button type="button" class="close" (click)="closeBtnClick()">
            <span>&times;</span>
        </button>
    </div>

    <form (ngSubmit)="onSubmit()" #donationForm="ngForm">
        <div class="modal-body">

            <div class="form-group">
                <label>Charity Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" name="charityName" [(ngModel)]="detail.charityName" required
                    #charityName="ngModel">

                <div class="text-danger" *ngIf="charityName.invalid && (charityName.dirty || charityName.touched)">
                    Charity Name is required
                </div>
            </div>

            <div class="form-group mt-3">
                <label>Description <span class="text-danger">*</span></label>
                <textarea class="form-control" name="charityDescription" [(ngModel)]="detail.charityDescription"
                    required #charityDescription="ngModel"></textarea>

                <div class="text-danger"
                    *ngIf="charityDescription.invalid && (charityDescription.dirty || charityDescription.touched)">
                    Description is required
                </div>
            </div>

            <div class="form-group mt-3">
                <label>Website Link</label>
                <input type="text" class="form-control" name="websiteLink" [(ngModel)]="detail.websiteLink">
            </div>

            <div class="form-group mt-3">
                <label>Charity Percentage (%) <span class="text-danger">*</span></label>
                <input type="number" class="form-control" name="donationPercentage"
                    [(ngModel)]="detail.donationPercentage" required #donationPercentage="ngModel">

                <div class="text-danger"
                    *ngIf="donationPercentage.invalid && (donationPercentage.dirty || donationPercentage.touched)">
                    Charity percentage is required
                </div>
            </div>

        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">Close</button>
            <button type="submit" class="btn btn-primary" [disabled]="donationForm.invalid">
                {{ modeltitle }}
            </button>
        </div>
    </form>
</ng-template>

<!-- DELETE MODAL -->
<ng-template #deleteModal>
    <div class="modal-header">
        <h5 class="modal-title">Delete Charity</h5>
        <button type="button" class="close" (click)="closeDeleteModalClick()">
            <span>&times;</span>
        </button>
    </div>

    <div class="modal-body">
        Are you sure you want to delete this Charity?
    </div>

    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeDeleteModalClick()">Cancel</button>
        <button class="btn btn-danger" (click)="confirmDelete()">Delete</button>
    </div>
</ng-template>